import React, { useState, useEffect } from "react"
import { useRouter } from "next/router"
import Sort from "@/components/ProductList/v2/Sort"
import Masonry from "react-masonry-css"
import ListTile from "@/components/MyFavorites/v1/MyList/ListTile"
import { useTranslation } from "next-i18next"
import SaveToList from "@/components/SaveToList"
import EmptyListPage from "@/components/MyFavorites/v1/MyList/EmptyListPage"
import { getTranslations } from "@/components/MyFavorites/v1/MyList/localization"
import ListDetails from "@/components/MyFavorites/v1/MyList/ListDetails"
import { MY_ACCOUNT_PATH, myListContainerBreakPoints } from "@/constants"
import { useSelector, useDispatch } from "react-redux"
import { selectGenericState } from "@/store/features/genericSlice"
import { MY_LISTS_PAGE_PATH } from "@/constants/routes"
import { getMyAccountListsWithLineItems } from "@/store/features/favoritesSlice"
import { dataLayerCreateNewMyListButton, dataLayerNewestToOldest, dataLayerOldestToNewest } from "@/components/MyFavorites/v1/MyList/analytics"

const MyLists = props => {
  const {  
    tabList = [],
    presetConfigs = "",
    sorts = [],
    tabChange = () => {},
    openCreateNewList = false,
    createNewListCallBAck = () => {},
    siteName = "",
    query = {},
    setIsListDetailsPage = () => {},
  } = props || {}

  const { t } = useTranslation("common")
  const router = useRouter()
  const dispatch = useDispatch()
  const staticText = getTranslations(t)
  const [selectedSort, setSelectedSort] = useState(sorts[0])
  const [isOpen, setIsOpen] = useState(false)
  const [userLists, setUserLists] = useState([])
  const [openCreateNewModal, setOpenCreateNewModal] = useState(false)
  const [selectedList, setSelectedList] = useState(null)
  const [hasListIdInUrlParams, setHasListIdInUrlParams] = useState(false)
  const {
    globalConfig: { internationalization: { language = "" } = {} } = {},
  } = useSelector(selectGenericState)

  const filteredList = userLists.filter(list => list.id === selectedList)  

  useEffect(() => {
    if (query?.listId) {
      const selectedList = userLists.filter(list => list.id === query?.listId)
      if (selectedList.length) {
        setHasListIdInUrlParams(true)
        setSelectedList(query?.listId)
        router.replace({
          pathname: `/${language}${MY_ACCOUNT_PATH}/${query?.slug[0]}`,
          query: { listId: query?.listId },
        })
      } else {
        router.push(`/${language}${MY_ACCOUNT_PATH}/${query?.slug[0]}`)
      }
    } else {
      setHasListIdInUrlParams(false)
      setSelectedList(null)
    }
  }, [query?.listId, userLists.length])

  useEffect(() => {
    localStorage.setItem("userListsLength", userLists.length)
  }, [userLists.length])

  const handleListDeleteSuccess = () => {
    setHasListIdInUrlParams(false)
    setSelectedList(null)
    router.replace(`/${language}${MY_LISTS_PAGE_PATH}`).then(() => {
      dispatch(getMyAccountListsWithLineItems())
    })
  }

  const handleSort = sortType => {
    const myListTitle = staticText?.myListPageTitle
    const sortTextTitle = staticText?.sortBy.replace(":", "")
    sortType?.query === "new" ? dataLayerNewestToOldest(myListTitle, sortTextTitle) : dataLayerOldestToNewest(myListTitle, sortTextTitle)
    setSelectedSort(sortType)
    sortType?.query == "new"
      ? setUserLists(
          userLists
            .slice()
            .sort(
              (a, b) =>
                new Date(b?.lastModifiedAt) - new Date(a?.lastModifiedAt)
            )
        )
      : setUserLists(
          userLists
            .slice()
            .sort(
              (a, b) =>
                new Date(a?.lastModifiedAt) - new Date(b?.lastModifiedAt)
            )
        )
  }

  const handleCreateNewList = () => {
    const myListTitle = staticText?.myListPageTitle
    const createNewListTitle = staticText?.createList
    setOpenCreateNewModal(true)
    dataLayerCreateNewMyListButton(myListTitle, createNewListTitle)
  }

  const handleCloseCreateNewList = () => {
    setOpenCreateNewModal(false)
    if (openCreateNewList) createNewListCallBAck(false)
  }
  const createNewListHandler = newList => {
    selectedSort?.query == "new"
      ? setUserLists([newList, ...userLists])
      : setUserLists([...userLists, newList])
    if (openCreateNewList) createNewListCallBAck(false)
  }
  const handleTabChange = tabIndex => {
    tabChange(tabIndex)
  }
  useEffect(() => {
    if (openCreateNewList) {
      setOpenCreateNewModal(true)
    }
  }, [openCreateNewList])
  useEffect(() => {
    if (tabList[0]?.data.length) {
      setUserLists(
        tabList[0]?.data
          ?.slice()
          .sort(
            (a, b) => new Date(b?.lastModifiedAt) - new Date(a?.lastModifiedAt)
          )
      )
    }
  }, [tabList])

  return (
    <>
      {selectedList && hasListIdInUrlParams ? (
        <ListDetails
          setIsListDetailsPage={setIsListDetailsPage}
          siteName={siteName}
          selectedId={selectedList}
          list={filteredList}
          hasListIdInUrlParams={hasListIdInUrlParams}
          setSelectedList={setSelectedList}
          deleteListSuccess={handleListDeleteSuccess}
          presetConfigs={presetConfigs}
        />
      ) : (
        <div className="container myListsWrapper">
          <div className="myListHeader">
            <div className="myListHeaderText">
              {staticText?.myListPageTitle}
            </div>
            <div className="myListCreateNew" onClick={handleCreateNewList}>
              {staticText?.createList}
            </div>
          </div>
          <div className="myListTabNamesContainer">
            <div className="myListTabNames">
              <div
                className="tabItem tabItemActive"
                onClick={() => {
                  handleTabChange(0)
                }}
              >
                <span className="tabNameText">{staticText?.tablTitle}</span>
              </div>
              {tabList.length > 1 ? (
                <div
                  className="tabItem"
                  onClick={() => {
                    handleTabChange(1)
                  }}
                >
                  <span className="tabNameText">
                    {staticText?.tablTitleMedia}
                  </span>
                </div>
              ) : null}
            </div>
          </div>
          {userLists.length ? (
            <div className="sortContainer">
              <div className="sortItem">
                <Sort
                  tabIndex={0}
                  page={"favorites"}
                  selectedtab={"0"}
                  data={sorts}
                  texts={{ sort: staticText?.sortBy }}
                  onChange={handleSort}
                  isOpen={isOpen}
                  setIsOpen={setIsOpen}
                  selectedSort={selectedSort}
                  isMyFavoriteTab={true}
                  isMyList={true}
                />
              </div>
            </div>
          ) : (
            <div className="createNewAndSort">
              <div className="createNewList" onClick={handleCreateNewList}>
                {staticText?.createList}
              </div>
              <div className="sortItem">
                <Sort
                  tabIndex={0}
                  page={"favorites"}
                  selectedtab={"0"}
                  data={sorts}
                  texts={{ sort: "Sort by:" }}
                  onChange={handleSort}
                  isOpen={isOpen}
                  setIsOpen={setIsOpen}
                  selectedSort={selectedSort}
                  isMyFavoriteTab={true}
                />
              </div>
            </div>
          )}
          {userLists.length ? (
            <Masonry
              breakpointCols={myListContainerBreakPoints}
              className="userListesConatiner"
              columnClassName="userListesConatinerColumn"
            >
              {userLists.map((list, index) => {
                return (
                  <ListTile
                    key={list?.id}
                    list={list}
                    presetConfigs={presetConfigs}
                    setSelectedList={setSelectedList}
                  />
                )
                
              })}
              
            </Masonry>
          ) : (
            <EmptyListPage />
          )}
        </div>
      )}
      {openCreateNewModal ? (
        <SaveToList
          showListSaveAndCreate={openCreateNewModal}
          createList={true}
          listSaveAndCreateClose={handleCloseCreateNewList}
          handleSuccessCallBack={createNewListHandler}
        />
      ) : null}
    </>
  )
}
export default MyLists
